module.exports = __webpack_public_path__ + "fbf7f082bb8abfeef11c89c77452f796.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/opensans-npm-webfont/fonts/opensansitalic.woff2
// module id = 684
// module chunks = 57